module.exports = __webpack_public_path__ + "static/kapten-logo-white-fc7bb9e561145a8dbcc90dfc148f6a33.png";